<div (cdkObserveContent)="contentChanged.emit()">
  <ng-template #simpleText>
    <div
      *ngIf="text || template"
      class="tooltip-container radius-12 p-3 text-white">
      <span class="body-3">{{ text }}</span>
    </div>
  </ng-template>
  <ng-template
    [ngTemplateOutlet]="template || simpleText"
    [ngTemplateOutletContext]="{ $implicit: text }"></ng-template>
</div>
